import { Component, Input, Output, ContentChildren, AfterContentInit, QueryList, EventEmitter } from '@angular/core';
import { SmFilterControlComponent } from './sm-filter-control.component';
import { ValueModel } from '../../core';
import { FilterItemModel, IFilterModel } from '../models/filter.models';

@Component({
	selector: 'sm-filter',
	template: require('./sm-filter.component.html')
})
export class SmFilterComponent implements AfterContentInit {
	private _filter: IFilterModel;

	@ContentChildren(SmFilterControlComponent) controls: QueryList<SmFilterControlComponent>;

	@Input() get filter() {
		if (!this._filter) {
			this._filter = { items: [] };
		}

		return this._filter;
	}
	set filter(val: IFilterModel) {
		this._filter = val;
	}

	@Output() onSubmit: EventEmitter<IFilterModel> = new EventEmitter();
	@Output() onChange: EventEmitter<IFilterModel> = new EventEmitter();

	get hasVisible() {
		return this.filter.items.find(x => !x.hidden) != null;
	}

	ngAfterContentInit() {
		this.controls.forEach(c => {
			c.model = this.filter.items.find((value: FilterItemModel) => value.id == c.code);
			c.onChanged.subscribe((s: FilterItemModel) => {
				let idx = this.filter.items.findIndex((value: FilterItemModel) => value.id == c.code);

				if (idx > -1) {
					let model = this.filter.items[idx];
					if (this.isEmpty(model)) {
						this.remove(model);
					}
					else {
						this.filter.items[idx] = s;
					}
				}
				else if (!this.isEmpty(s)) {
					this.filter.items.push(s);
				}
			});
		});
	}

	isEmpty(model: FilterItemModel) {
		return !model || (model.values.length < 1 && (!model.range || (model.range.start == null && model.range.end == null)));
	}

	isRangeNumber(value: any): boolean {
		return typeof value.start == 'number' || typeof value.end == 'number';
	}

	isRangeDate(value: any): boolean {
		return value.start instanceof Date || value.end instanceof Date;
	}

	removeAll() {
		let idx, re;
		do {
			idx = this.filter.items.findIndex(x => !x.hidden);
			if (idx >= 0) {
				re = this.filter.items[idx];
				if (re) {
					this.clear(re);
				}
				this.filter.items.splice(idx, 1);
			}
		}
		while (idx >= 0);

		this.submit();
	}

	clear(model: FilterItemModel) {
		model.values.length = 0;
		model.range.start = null;
		model.range.end = null;
	}

	remove(model: FilterItemModel) {
		const idx = this.filter.items.indexOf(model);

		this.clear(model);

		if (idx > -1) {
			this.filter.items.splice(idx, 1);
		}
	}

	removeValue(model: FilterItemModel, valueIndex: number) {
		model.values.splice(valueIndex, 1);
		if (model.values.length == 0) {
			this.remove(model);
		}
	}

	submit() {
		this.onSubmit.emit(this._filter);
	}
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/components/sm-filter.component.ts